import { Button, Stack, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AnimateButton from 'components/@extended/AnimateButton';
import { useNavigate, useLocation } from 'react-router-dom';
import { dispatch, useSelector } from 'store';
import { activeItem } from 'store/reducers/menu';
import { isReceptionist, RECEPTIONIST_ACCENT, RECEPTIONIST_SIDEBAR_BG, RECEPTIONIST_SURFACE } from '../MiniDrawerStyled';
import { Profile2User, UserTick } from 'iconsax-react';
import { getCheckInDestination, hasBothCheckInFlows, hasCheckInAccess, hasFrontdeskCheckInPermission } from 'utils/checkinRoute';
const NavCard = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  // Receptionist's maroon rail gets a matching Check-In button instead of the default blue —
  // same soft-pill-that-fills-solid-on-hover pattern, just tinted to the sidebar's own colors.
  const receptionist = isReceptionist();

  const permissions = useSelector((state) => state.auth?.permissions || []);
  const canCheckIn = hasCheckInAccess(permissions, receptionist);
  const usesFrontdeskTheme = receptionist || hasFrontdeskCheckInPermission(permissions);
  const checkInBg = usesFrontdeskTheme ? RECEPTIONIST_SURFACE : theme.palette.primary.lighter;
  const checkInColor = usesFrontdeskTheme ? RECEPTIONIST_SIDEBAR_BG : theme.palette.primary.darker;
  const checkInHoverBg = usesFrontdeskTheme ? RECEPTIONIST_ACCENT : theme.palette.primary.main;
  const checkInHoverColor = usesFrontdeskTheme ? RECEPTIONIST_SIDEBAR_BG : '#ffffff';

  // Only show two explicit Check-In entry points when the user actually holds both
  // Front Desk and Visitor Office check-in flow permissions.
  const showBothCheckIns = hasBothCheckInFlows(permissions, receptionist);
  const buttonBaseSx = {
    display: 'flex',
    gap: 1.25,
    justifyContent: 'center',
    alignItems: 'center',
    py: '12px',
    borderRadius: 1,
    boxShadow: '0px 4px 10px rgba(0, 51, 153, 0.3)',
    width: {
      xs: '160px',
      sm: '180px',
      md: '200px'
    }
  };

  const frontButtonSx = {
    ...buttonBaseSx,
    bgcolor: RECEPTIONIST_SURFACE,
    color: RECEPTIONIST_SIDEBAR_BG,
    '&:hover': {
      bgcolor: RECEPTIONIST_ACCENT,
      boxShadow: 'none',
      color: RECEPTIONIST_SIDEBAR_BG
    }
  };

  const vmsButtonSx = {
    ...buttonBaseSx,
    bgcolor: theme.palette.primary.lighter,
    color: theme.palette.primary.darker,
    '&:hover': {
      bgcolor: theme.palette.primary.main,
      boxShadow: 'none',
      color: '#ffffff'
    }
  };

  const buttonSx = {
    ...buttonBaseSx,
    bgcolor: checkInBg,
    color: checkInColor,
    '&:hover': {
      bgcolor: checkInHoverBg,
      boxShadow: 'none',
      color: checkInHoverColor
    }
  };

  const handleNavigate = (path, state = {}) => {
    // Check-In isn't one of the tracked sidebar menu items, so nothing would otherwise clear
    // whichever item (e.g. Dashboard) was last active — leaving it visually highlighted even
    // though the user has navigated away from it.
    dispatch(activeItem({ openItem: [] }));
    if (location.pathname === path) {
      window.location.href = path;
    } else {
      navigate(path, { state });
    }
  };

  const destinationPath = getCheckInDestination(permissions, receptionist);

  return (
    <Grid container sx={{ p: 3, maxWidth: '100vw', overflow: 'hidden' }}>
      <Grid item xs={12}>
        <Stack alignItems="center" spacing={2}>
          {showBothCheckIns ? (
            <>
              <AnimateButton>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNavigate('/vms/checkin/frontdesk');
                  }}
                  sx={frontButtonSx}
                >
                  <UserTick />
                  <Typography component="span" sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
                    Check-in - Front
                  </Typography>
                </Button>
              </AnimateButton>
              <AnimateButton>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNavigate('/vms/checkin');
                  }}
                  sx={vmsButtonSx}
                >
                  <Profile2User />
                  <Typography component="span" sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
                    Check-in - VMS
                  </Typography>
                </Button>
              </AnimateButton>
            </>
          ) : (
            canCheckIn && (
              <>
                {/* --- PRIMARY BUTTON (Check-In) --- */}
                <AnimateButton>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNavigate(destinationPath, { detail: true });
                    }}
                    sx={buttonSx}
                  >
                    <UserTick />
                    <Typography
                      component="span"
                      sx={{
                        fontSize: '0.875rem',
                        fontWeight: 600
                      }}
                    >
                      Check-In
                    </Typography>
                  </Button>
                </AnimateButton>

                {/* --- SECONDARY BUTTON (Generate OTP) --- */}
              {/* <AnimateButton>
              <Button
                variant="outlined" // Using outlined for the "Ghost" look
                fullWidth
                onClick={() => handleNavigate('/vms/generateotp')}
                sx={{
                  color: '#003399',
                  borderColor: '#003399',
                  bgcolor: 'rgba(255, 255, 255, 0.4)', // Slight transparency
                  borderRadius: '8px',
                  borderWidth: '1.5px',
                  // Responsive Widths matching the primary
                  width: { xs: '160px', sm: '180px', md: '200px' },
                  '&:hover': { 
                    borderWidth: '1.5px', 
                    bgcolor: 'rgba(0, 51, 153, 0.05)',
                    borderColor: '#003399' 
                  }
                }}
              >
                <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
                  Generate OTP
                </Typography>
              </Button>
            </AnimateButton> */}
              </>
            )
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default NavCard;
